import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  gBox: {
    alignItems: 'center',
    width: 150,
    marginLeft: 40,
    display: 'flex',
  },
  divBlock168: { width: 24, height: 24 },
  divBlock169: {
    flexFlow: 'column',
    justifyContent: 'center',
    height: 28,
    marginLeft: 10,
    display: 'flex',
  },
  divBlock170: {
    alignItems: 'center',
    height: 14,
    display: 'flex',
  },
  divBlock171: {
    alignItems: 'center',
    height: 14,
    display: 'flex',
  },
  gText: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 10,
    lineHeight: 12,
  },
  image44: {
    height: 12,
    marginRight: 6,
  },
}));

const GoogleTrust: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.gBox}>
      <div className={classes.divBlock168}>
        <img
          src="https://a-w.mineko.de/632dfbc98f8e3608bb0a6e68/63d9884331f6afd6765ae4ad_google-g.svg"
          loading="lazy"
          alt="Google"
        />
      </div>
      <div className={classes.divBlock169}>
        <div className={classes.divBlock171}>
          <div className={classes.gText}>Google Rezensionen</div>
        </div>
        <div className={classes.divBlock170}>
          <img
            src="https://a-w.mineko.de/632dfbc98f8e3608bb0a6e68/63d98e062f85c34793acd78b_5-stars.svg"
            loading="lazy"
            alt="5 Sterne"
            className={classes.image44}
          />
          <div className={classes.gText}>(500+)</div>
        </div>
      </div>
    </div>
  );
};

export default GoogleTrust;
